<template>
  <div>
    <div class="admin">
      <div class="fluid-container">
        <div class="row no-gutters">
          <!-- menu admin -->
          <div class="col-3">
            <menu-admin></menu-admin>
          </div>
          <!-- menu admin -->

          <!-- main -->
          <div class="col-9 main pb-5">
            <div class="row">
              <div class="col-12 mb-2">
                <div class="title-admin">
                  <h1 class="display-5 font-weight-black">Agregar producto</h1>

                  <v-btn color="grey" outlined dark to="/admin/productos">
                    <v-icon left>keyboard_backspace</v-icon>Regresar a productos
                  </v-btn>
                </div>
              </div>
            </div>

            <div class="row mt-4">
              <!-- producto form -->
              <div class="col-12 pb-5 mb-5">
                <v-text-field
                  v-model="nombre"
                  label="Nombre del producto"
                  outlined
                  placeholder="nombre"
                ></v-text-field>

                <v-text-field
                  v-model="sku"
                  label="SKU"
                  outlined
                  placeholder="sku"
                ></v-text-field>

                <v-select
                  :items="categorias"
                  label="Categorías"
                  v-model="categoria"
                  outlined
                  item-text="nombre"
                  item-value="id"
                  placeholder="Selecciona la categoría"
                ></v-select>

                <div>
                  <v-text-field
                    class="mb-7"
                    v-model="precio_pesos"
                    label="Precio Regular"
                    outlined
                    placeholder="$"
                    hide-details
                  ></v-text-field>
                </div>

                <div>
                  <v-text-field
                    v-model="precio_oferta_pesos"
                    label="Precio Oferta"
                    outlined
                    placeholder="$"
                    hide-details
                  ></v-text-field>
                </div>

                <div style="margin-top: 30px">
                  <v-textarea
                    outlined
                    v-model="descripcion_espanol"
                    placeholder="Escribe la descripción del producto"
                    auto-grow
                    label="Descripción del producto en español"
                  ></v-textarea>
                </div>

                <v-text-field
                  v-model="inventario"
                  label="Cantidad de productos en stock"
                  outlined
                  placeholder="inventario"
                  @change="changeToDollar()"
                  hide-details
                ></v-text-field>

                <v-switch
                  v-model="visible"
                  :label="
                    ` ${
                      visible
                        ? 'Si debe estar visible en la pagina web'
                        : 'No debe de estar visible en la pagina web'
                    }`
                  "
                ></v-switch>

                <v-btn class="mt-5" large color="primary" @click="validar()"
                  >guardar producto</v-btn
                >
              </div>
              <!-- /producto form -->
            </div>
          </div>
          <!-- /main -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const axios = require("axios");
import router from "@/router";
export default {
  data() {
    return {
      categorias: [],
      visible: false,
      error: "",
      nombre: "",
      categoria: "selected",
      precio_pesos: "",
      precio_oferta_pesos: "",
      precio_dolares: "",
      inventario: "",
      sku: "",
      descripcion_ingles: "",
      descripcion_espanol: "",
      loader: false,
    };
  },
  methods: {
    validar() {
      if (this.nombre == "") {
        this.$swal({
          type: "error",
          title: "Ingresa el nombre del producto",
          showConfirmButton: true,
        });
      } else if (this.sku == "") {
        this.$swal({
          type: "error",
          title: "Ingresa el SKU del producto",
          showConfirmButton: true,
        });
      } else if (this.categoria == "" || this.categoria == "selected") {
        this.$swal({
          type: "error",
          title: "Selecciona la categoría del producto",
          showConfirmButton: true,
        });
      } else if (this.precio_pesos == "") {
        this.$swal({
          type: "error",
          title: "Selecciona el precio del producto en pesos",
          showConfirmButton: true,
        });
      } else if (this.inventario == "") {
        this.error = this.$swal({
          type: "error",
          title: "Selecciona la cantidad de productos en stock",
          showConfirmButton: true,
        });
      } else {
        //Los datos requeridos se ingresaron
        this.guardar();
      }
    },

    getCategorias() {
      //Obtenemos los productos
      axios
        .get(
          "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=getCategorias"
        )
        .then((response) => {
          console.log(response);
          this.categorias = response.data;
          this.loader = false;
        })
        .catch((error) => console.log(error));
    },
    changeToDollar() {
      this.precio_dolares = this.precio_pesos / 16;
      console.log(this.precio_dolares);
    },
    guardar() {
      this.loader = true;
      if (this.visible) {
        this.visible = 1;
      } else {
        this.visible = 0;
      }
      axios
        .get(
          "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=saveProducto" +
            "&nombre=" +
            this.nombre +
            "&sku=" +
            this.sku +
            "&categoria=" +
            this.categoria +
            "&inventario=" +
            this.inventario +
            "&precio_pesos=" +
            this.precio_pesos +
            "&precio_pesos_oferta=" +
            this.precio_oferta_pesos +
            "&precio_dolares=" +
            this.precio_dolares +
            "&descripcion_espanol=" +
            this.descripcion_espanol +
            "&descripcion_ingles=" +
            this.descripcion_ingles +
            "&visible=" +
            this.visible
        )
        .then((response) => {
          router.push({
            name: "producto_editar_admin",
            params: { id: response.data.id },
          });
        })
        .catch((error) => console.log(error));
    },
  },
  computed: {},
  mounted() {
    this.getCategorias();
  },
};
</script>
